export function calcPercentage(partialValue, totalValue) {
  const result = (100 * partialValue) / totalValue;
  return !Number.isNaN(result) ? result : 0;
}